import { SiloTableCell } from './SiloTableCell';
import { SiloListEntry } from './SiloListEntry';

const SiloEntry = {
    List: SiloListEntry,
    Cell: SiloTableCell,
};

export { SiloEntry };
